<template>
    <div id="app">
<!--        <div id="nav">-->
<!--            <router-link to="/">Home</router-link> |-->
<!--            <router-link to="/about">About</router-link>-->
<!--        </div>-->
        <router-view/>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'App',
        created() {
            this.interceptRequest();
        },
        methods: {
            interceptRequest() {
                this.$http.interceptors.request.use(
                    (request) => {
                        if (localStorage.getItem('auth')) {
                            request.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('auth')).accessToken}`;
                        }
                        return request;
                    },
                    (error) => {
                        console.error(error);
                        return Promise.reject(error);
                    }
                );
                this.$http.interceptors.response.use(
                    (response) => {
                        return response;
                    },
                    (error) => {
                        console.error(error);
                        if (error.response.status === 401 && error.response.data.subCode === 1401) {
                            this.$http.post(
                                `${this.apiURL}/user/renew-token`,
                                {
                                    userId: JSON.parse(localStorage.getItem('auth')).user._id,
                                    refreshToken: JSON.parse(localStorage.getItem('auth')).refreshToken
                                }
                            ).then(
                                (response) => {
                                    // let refreshToken = JSON.parse(localStorage.getItem('auth')).refreshToken;
                                    let userData = JSON.parse(localStorage.getItem('auth')).user;

                                    localStorage.setItem('auth', JSON.stringify(
                                        {
                                            accessToken: response.data.accessToken,
                                            refreshToken: response.data.refreshToken,
                                            refreshTokenExp: response.data.refreshTokenExp,
                                            user: userData
                                        }
                                    ));

                                    // return axios(error.config)
                                    this.$router.go();
                                    return this.$http.request(error.config)
                                }
                            ).catch(
                                (e) => {
                                    console.error(e);
                                    return Promise.reject(error);
                                }
                            );
                        }
                        else if (error.response.status === 401 && error.response.data.subCode === 1410) {
                            localStorage.removeItem('auth');
                            this.$router.push({name: 'auth-signin'});
                            return Promise.reject(error);
                        }
                        else {
                            return Promise.reject(error);
                        }
                    }
                );
                /*
                this.$http.interceptors.response.use(
                    (response) => {
                        return response;
                    },
                    (error) => {
                        if (401 === error.response.status) {

                                error.config.headers['Authorization'] = 'Bearer '+ JSON.parse(localStorage.getItem('auth')).token;
                                return axios(error.config)
                            }
                            else {
                                return Promise.reject(error);
                            }
                        }
                        else {
                            return Promise.reject(error);
                        }
                    }
                );*/
            }
        }

    };
</script>

<style lang="scss">
    @import 'main';
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        /*margin-top: 60px;*/
    }
</style>
